export const ROLES = [
	'superuser' as const,
	'teamMemberReadonly' as const,
	'bot' as const,
	'teamMember' as const,
	'moderator' as const,
]
